import React, { useState, useEffect, useMemo } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useAuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const SubscriptionBanner = () => {
  const { authState } = useAuthContext();
  const navigate = useNavigate();
  const [banner, setBanner] = useState({ show: false, message: '', variant: 'warning' });

  const { subscription, subscriptionStatus, isFetchingSubscription, isAuthenticated } = authState;

  useEffect(() => {
    // Esconde o banner se o usuário não estiver autenticado ou se os dados estiverem carregando
    if (!isAuthenticated || isFetchingSubscription) {
      setBanner(prev => ({ ...prev, show: false }));
      return;
    }

    // Lógica para planos com problemas (expirado, cancelado, etc.)
    if (['canceled', 'past_due', 'unpaid'].includes(subscriptionStatus)) {
      setBanner({
        show: true,
        message: 'Seu acesso à plataforma está limitado. Para continuar utilizando todas as funcionalidades, por favor, regularize seu plano.',
        variant: 'danger',
      });
      return;
    }

    // --- LÓGICA REATORADA ---
    // Verifica a data de expiração para todos os planos que não são vitalícios.
    if (
      subscription &&
      subscription.plan &&
      !subscription.plan.is_lifetime && // Ignora planos vitalícios
      subscription.current_period_ends_at
    ) {
      const expirationDate = new Date(subscription.current_period_ends_at + 'T00:00:00');
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const diffTime = expirationDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Apenas mostra o banner se o plano estiver para expirar (ou já expirou)
      if (diffDays <= 5) {
        // Se o plano já expirou (diffDays < 0), mostra a mensagem para TODOS os tipos de plano.
        if (diffDays < 0) {
          setBanner({
            show: true,
            message: `Seu plano expirou há ${Math.abs(diffDays)} dia(s). Para evitar a interrupção dos serviços, regularize sua assinatura.`,
            variant: 'danger',
          });
        // Se o plano está PRESTES a expirar, mostra a mensagem APENAS para os planos específicos.
        } else if (['Plano de Teste', 'Plano Essencial'].includes(subscription.plan?.name)) {
          setBanner({
            show: true,
            message: `Seu plano expira em ${diffDays} dia(s). Garanta o acesso contínuo à plataforma.`,
            variant: 'warning',
          });
        }
        return;
      }
    }
    // --- FIM DA LÓGICA REATORADA ---


    // Se nenhuma das condições acima for atendida, esconde o banner
    setBanner(prev => ({ ...prev, show: false }));

  }, [isAuthenticated, isFetchingSubscription, subscription, subscriptionStatus]);

  if (!banner.show) {
    return null;
  }

  const Icon = banner.variant === 'danger' ? faExclamationTriangle : faInfoCircle;

  return (
    <Alert
      variant={banner.variant}
      className="text-center mb-0 rounded-0 py-2"
      style={{ position: 'sticky', top: 0, zIndex: 1049 }} // Z-index um pouco menor que o da personificação
    >
      <Container className="d-flex justify-content-center align-items-center">
        <FontAwesomeIcon icon={Icon} className="me-2" />
        <span className="me-3">{banner.message}</span>
        <Button variant={`outline-${banner.variant}`} size="sm" onClick={() => navigate('/pricing')}>
          Ver Planos
        </Button>
      </Container>
    </Alert>
  );
};

export default SubscriptionBanner;
